import { render } from "./AlarmI18nNames.vue?vue&type=template&id=713eb280&scoped=true"
import script from "./AlarmI18nNames.vue?vue&type=script&lang=js"
export * from "./AlarmI18nNames.vue?vue&type=script&lang=js"

import "./AlarmI18nNames.vue?vue&type=style&index=0&id=713eb280&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713eb280"]])

export default __exports__